import './styles/SlidePanel.css';
import SlidePanel from './SlidePanel';
export default SlidePanel;
